import * as React from 'react';
export const signalSvg = React.forwardRef(function signalSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1 14v-3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0Zm4 0V8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0Zm4 0V5a1 1 0 1 1 2 0v9a1 1 0 1 1-2 0Zm4 0V2a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0Z',
    }),
  );
});
signalSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var signal = {
  category: 'icon',
  colorable: true,
  name: 'signal',
  svg: signalSvg,
};
